module.exports = require('./helpers/bundle-url').getBundleURL('1D4ws') + "logo-dark.ba5147f0.svg";